<template>
  <div v-if="category">

    <p class="tabs">
      <router-link
        v-for="tab in categories"
        class="tab"
        active-class="tab--active"
        :key="tab.id"
        :to="urlForCategory(tab)"
      >
        {{ tab.name }}
        <i class="fa fa-check" v-if="hasSelectedNominee(tab)"></i>
      </router-link>
    </p>
    <div v-if="selectedNominee || selectedSuggestion">

      <template v-if="selectedSuggestion">
        <div class="breadcrumb ml--lg">
          <router-link :to="{ name: 'home' }">Categorie</router-link>
          <span>{{ category.name }}</span>
        </div>

        <div class="p--md container--border">
          <h1 class="p--md">Jouw suggestie</h1>
          <div class="content">
            <img class="img--box is-pulled-left" src="static/rr_fallback.png" />
            <h2>{{ selectedSuggestion.suggestionName }}</h2>
            <p v-if="selectedSuggestion.suggestionStation">
              {{ selectedSuggestion.suggestionStation }}
            </p>
            <a href="#" class="button button--small mt--md" @click.prevent="clearCategory">
              Wijzigen
            </a>
          </div>
          <div class="p--md">
            <template v-if="otherCategories.length">
              <p class="paragraph">
                <strong>Vergeet niet</strong> om ook een keuze te maken voor de categorie
                <template v-for="(otherCategory, index) in otherCategories">
                <span v-if="index > 0 && index < otherCategories.length" v-bind:key="otherCategory.name"
                >en/of</span
                >
                  <router-link style="color: #FBCA5F" :key="otherCategory.id" :to="urlForCategory(otherCategory)">
                    {{ otherCategory.name }}
                  </router-link>
                </template>
              </p>
            </template>
          </div>
          <div class="p--md" style="align-content: end;">
            <router-link class="button button-confirm button--accent" :to="{ name: 'submit' }">
              Stemmen afronden
              <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
            </router-link>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="breadcrumb ml--lg">
          <router-link :to="{ name: 'home' }">Categorie</router-link>
          <span>{{ category.name }}</span>
        </div>
        <div class="p--md container--border">
          <h1 class="p--md title">Jouw keuze</h1>
          <div class="content">
            <img
              class="img--box is-pulled-left"
              v-if="selectedNominee.image"
              :src="selectedNominee.image"
              onerror="this.src='static/rr_fallback.png';"
            />
            <img class="img--box is-pulled-left" v-else src="static/rr_fallback.png" />
            <h2 class="nameHeader">{{ selectedNominee.name }}</h2>
            <h3 class="text-md" v-for="station in selectedNominee.stations">{{station}}</h3>
            <p class="description" v-if="selectedNominee.secondaryName">
              {{ selectedNominee.secondaryName }}
            </p>
            <p v-if="selectedNominee.knownFor">{{ selectedNominee.knownFor }}</p>
            <a href="#" class="button button--small mt--md" @click.prevent="clearCategory">
              Wijzigen
            </a>
          </div>

          <div class="p--md">
            <template v-if="otherCategories.length">
              <p class="paragraph">
                <strong>Vergeet niet</strong> om ook een keuze te maken voor de categorie

                <template v-for="(otherCategory, index) in otherCategories">
              <span v-if="index > 0 && index < otherCategories.length" v-bind:key="otherCategory.name"
              >en/of</span
              >
                  <router-link style="color: #FBCA5F" :key="otherCategory.id" :to="urlForCategory(otherCategory)">
                    {{ otherCategory.name }}
                  </router-link>
                </template>
              </p>
            </template>
          </div>
          <div class="p--md" style="align-content: end;">
            <router-link class="button button-confirm button--accent" :to="{ name: 'submit' }">
              Stemmen afronden
              <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
            </router-link>
          </div>
        </div>
      </template>
    </div>

    <div v-if="!selectedNominee && !selectedSuggestion" class="search mx--lg" :class="{ 'search--fixed': searchFixed }">
      <div v-if="category">
        <div class="button-group is-pulled-right">
          <button
            v-for="sortable in sortTypes"
            :key="sortable.type"
            :title="sortable.title"
            @click.prevent="setSortType(sortable)"
            type="button"
            class="button-icon"
            :class="{ 'button-icon--active': sortType === sortable.type }"
          >
            <i class="fa fa-fw" :class="sortable.icon" aria-hidden="true"></i>
          </button>
        </div>

        <div class="breadcrumb">
          <router-link :to="{ name: 'home' }">Categorie</router-link>
          <span>{{ category.name }}</span>
        </div>

        <div class="search-bar" ref="searchBar" style="width: auto;">
          <div class="form__field form__field--icon form__field--search">
            <input
              type="text"
              class="form__input"
              placeholder="Zoek"
              ref="searchInput"
              aria-label="Zoekterm"
              @input="updateKeyword"
              @focus="onFocusSearch"
              :value="category.keyword"
            />
            <i class="fa fa-search" aria-hidden="true"></i>

            <a
              v-if="allowSuggestions && category.name === 'Podcast' "
              class="button mt--md"
              @click.prevent="showSuggestionModal = true"
            >
              Of voeg een suggestie toe
            </a>
          </div>
        </div>
        <button v-if="category.name !== 'Podcast'" class="filterButton" @click="showFilters = !showFilters">
          Filters
        </button>
        <div id="filters" v-if="showFilters === true && category.name !== 'Podcast'">
          <div class="filter">
            <p class="tag-list">
              <span
                v-for="(showtime, key) in showtimesTags"
                :key="key"
                @click="toggleDayPartTag(key)"
                :class="classForDayPartTag(key)"
              >
                <i class="fa fa-clock-o" aria-hidden="true" v-if="!isIOSSmall"></i>
                {{ showtime }}
              </span>
            </p>
          </div>

          <div class="filter mb--md" v-if="stationsTags.length > 0">
            <p class="tag-list">
              <span
                v-for="(station, key) in stationsTags"
                :key="key"
                @click="toggleStationTag(station)"
                :class="classForStationTag(station)"
              >
                {{ station }}
              </span>
            </p>
          </div>
        </div>
      </div>

      <div class="nominee--container">
        <div class="grid grid--center" ref="grid" v-if="filteredNominees.length" :key="category.id">
          <div
            :class="classForGridItem(filteredNominees)"
            v-for="nominee in filteredNominees"
            :key="nominee.id"
          >
            <nominee-item
              :class="classForNominee(nominee)"
              :nominee="nominee"
              :category="category"
              :key="nominee.id"
            />
          </div>
        </div>
        <p v-else class="p--md">
          Er zijn geen genomineerden gevonden binnen de opgegeven criteria.
        </p>
      </div>
    </div>
    <nominee-modal
      v-if="activeNominee"
      :filteredNominees="filteredNominees"
      :nomineeId="activeNominee.id"
      :categoryId="category.id"
    />
    <suggestion-modal
      v-if="showSuggestionModal"
      :categoryId="category.id"
      @closeModal="showSuggestionModal = false"
    />
  </div>
  <p v-else class="p--md">
    Deze pagina bestaat niet (meer).
    <router-link :to="{ name: 'home' }">Klik hier om terug te keren naar de homepage</router-link>.
  </p>
</template>

<script>
import NomineeItem from './NomineeItem'
import NomineeModal from './NomineeModal'
import SuggestionModal from './SuggestionModal'
import triggerResize from '@/util/triggerResize'
import { SORT_ASC, SORT_DESC, SORT_RANDOM } from '@/sortTypes'

const HYPHENATE_AT = 11
const HAS_TOUCH = 'ontouchstart' in document.documentElement
const IS_IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
const IS_IOS_SMALL = /iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
// iOS has issues with the virtual keyboard overlapping the input
const SEARCH_FIXED = HAS_TOUCH && !IS_IOS

const sortTypes = [
  { type: SORT_ASC, icon: 'fa-long-arrow-down', title: 'Oplopend' },
  { type: SORT_DESC, icon: 'fa-long-arrow-up', title: 'Aflopend' },
  { type: SORT_RANDOM, icon: 'fa-random', title: 'Willekeurig' },
]

export default {
  name: 'Category',
  props: {
    categoryId: {
      type: Number,
      required: true
    },
    nomineeId: {
      type: Number,
      required: false
    },
  },
  data() {
    return {
      hasTouch: HAS_TOUCH,
      isIOS: IS_IOS,
      isIOSSmall: IS_IOS_SMALL,
      searchFixed: SEARCH_FIXED,
      sortTypes,
      showSuggestionModal: false,
      showFilters: false
    }
  },
  components: {
    'nominee-modal': NomineeModal,
    'suggestion-modal': SuggestionModal,
    'nominee-item': NomineeItem
  },
  methods: {
    setSortType(sortType) {
      this.$store.dispatch('setSortType', {
        categoryId: this.category.id,
        sortType: sortType.type
      })
    },
    onFocusSearch() {
      const { grid } = this.$refs

      if (SEARCH_FIXED && grid && grid.scrollIntoView) {
        grid.scrollIntoView()
      }
    },
    clearCategory() {
      this.$store.dispatch('clearCategory', {
        categoryId: this.category.id
      })
    },
    stylesForNominee(nominee) {
      return nominee.image
        ? {
            backgroundImage: `url(${nominee.image})`
          }
        : {}
    },
    classForStationTag(tag) {
      return {
        tag: true,
        'tag--active': this.isSelectedChannelTag(tag)
      }
    },
    classForDayPartTag(tag) {
      return {
        tag: true,
        'tag--daypart': true,
        'tag--active': this.isSelectedDayPartTag(tag)
      }
    },
    classForGridItem(filteredNominees) {
      return {
        grid__item: true,
        'grid__item--few': filteredNominees.length <= 10
      }
    },
    isSelectedChannelTag(tag) {
      return this.selectedChannelId === tag
    },
    isSelectedDayPartTag(tag) {
      return this.selectedDayPartId === tag
    },
    toggleStationTag(tag) {
      this.$store.dispatch('setSelectedChannelId', {
        tagId: tag,
        categoryId: this.category.id
      })
    },
    toggleDayPartTag(tag) {
      this.$store.dispatch('setSelectedDayPartId', {
        tagId: tag,
        categoryId: this.category.id
      })
    },
    updateKeyword(e) {
      this.$store.dispatch('setKeyword', {
        keyword: e.target.value,
        categoryId: this.category.id
      })
    },
    urlForCategory(category) {
      return {
        name: 'category',
        params: {
          categoryId: category.id
        }
      }
    },
    urlForNominee(nominee) {
      return {
        name: 'nominee',
        params: {
          categoryId: this.category.id,
          nomineeId: nominee.id,
          nomineeSlug: nominee.slug
        }
      }
    },
    classForNominee(nominee) {
      return {
        item: true,
        'item--nominee': true,
        'item--disabled': this.activeNominee && !(this.activeNominee.id === nominee.id),
        'item--selected': this.isSelectedNominee(nominee),
        'item--hyphenate': nominee.name.split(' ').some(word => word.length > HYPHENATE_AT)
      }
    },
    isSelectedNominee(nominee) {
      return this.selected.find(({ nomineeId }) => nomineeId === nominee.id)
    },
    hasSelectedNominee(category) {
      return this.selected.find(({ categoryId }) => categoryId === category.id)
    },
  },
  watch: {
    category: {
      handler() {
        triggerResize()
      },
      deep: true
    }
  },
  computed: {
    selectedChannelId() {
      return this.category.selectedChannelId
    },
    selectedDayPartId() {
      return this.category.selectedDayPartId
    },
    keyword() {
      return this.category.keyword
    },
    sortType() {
      return this.category.sortType
    },
    selected() {
      return this.$store.state.selected
    },
    loaded() {
      return this.$store.state.loaded
    },
    selectedNominee() {
      const selected = this.selected.find(({ categoryId }) => categoryId === this.category.id)

      return selected ? this.nominees.find(nominee => nominee.id === selected.nomineeId) : null
    },
    selectedSuggestion() {
      const selected = this.selected.find(({ categoryId }) => categoryId === this.category.id)

      if (!selected || typeof selected.suggestionName === 'undefined') {
        return null
      }

      return selected
    },
    categories() {
      return this.$store.state.categories
    },
    otherCategories() {
      return this.categories.filter(
        category => !this.selected.some(({ categoryId }) => categoryId === category.id)
      )
    },
    category() {
      return this.categories.find(({ id }) => id === this.categoryId)
    },

    nominees() {
      return this.$store.getters.getNomineesByCategoryId(this.category.id)
    },
    activeNominee() {
      return this.nomineeId ? this.filteredNominees.find(({ id }) => id === this.nomineeId) : null
    },
    filteredNominees() {
      return this.$store.getters.getFilteredNomineesByCategoryId(this.category.id).sort()
    },
    tags() {
      const normalized = {}

      this.nominees.forEach(nominee => {
        if (nominee.showtimes) {
          nominee.showtimes.forEach(tag => {
            normalized[tag.id] = tag
          })
        }
      })

      return Object.values(normalized)
    },
    showtimesTags() {
      return this.$store.state.showtimesTags
    },
    stationsTags() {
        return this.$store.state.stationsTags[this.category.id].sort();
    },
    allowSuggestions() {
      return this.$store.state.allowSuggestions
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Category.vue